var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center mt-8"},[_c('BaseButton',_vm._b({class:{
      'opacity-50': _vm.invalid || _vm.disabled,
      'btn-tertiary': true,
    },attrs:{"type":"submit","title":_vm.title,"large":"","disabled":_vm.disabled || _vm.invalid}},'BaseButton',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }